// Utilidades para RUT chileno: normalización + formato con guion + validación módulo 11.
//
// Uso:
//   import { formatRut, cleanRut, validateRut, isValidRut } from "@/lib/rut";
//
//   onChange={(e) => set("rut", formatRut(e.target.value))}
//   const canonical = cleanRut(form.rut)  // "12345678-9" listo para enviar al backend
//   if (!isValidRut(form.rut)) setError("RUT inválido")

/** Limpia el RUT a su forma canónica `DDDDDDDD-V` (sin puntos, con guion, V en mayúsculas). */
export function cleanRut(input) {
  if (!input) return "";
  const raw = String(input).replace(/[^0-9kK]/g, "").toUpperCase();
  if (raw.length < 2) return raw;
  const body = raw.slice(0, -1);
  const dv = raw.slice(-1);
  return `${body}-${dv}`;
}

/** Formato "on-the-fly" para el input: agrega guion automático antes del dígito verificador.
 *  El usuario tipea solo números/K, ve automáticamente `12345678-9`. No obliga puntos. */
export function formatRut(input) {
  if (!input) return "";
  const raw = String(input).replace(/[^0-9kK]/g, "").toUpperCase();
  if (raw.length === 0) return "";
  if (raw.length === 1) return raw;
  return `${raw.slice(0, -1)}-${raw.slice(-1)}`;
}

/** Calcula dígito verificador esperado para un cuerpo numérico (string de solo dígitos). */
function computeDv(body) {
  let sum = 0;
  let mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number(body[i]) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const rest = 11 - (sum % 11);
  if (rest === 11) return "0";
  if (rest === 10) return "K";
  return String(rest);
}

/** Validación estricta: body 7-8 dígitos y dígito verificador módulo 11 correcto. */
export function validateRut(input) {
  if (!input) return false;
  const canonical = cleanRut(input);
  const parts = canonical.split("-");
  if (parts.length !== 2) return false;
  const [body, dv] = parts;
  if (!/^\d{7,8}$/.test(body)) return false;
  if (!/^[0-9K]$/.test(dv)) return false;
  return computeDv(body) === dv;
}

/** Alias más natural para condicionales. */
export const isValidRut = validateRut;
